
<app-change-course-header
  [heading]="getHeader()"
  [showChangeCourse]="true"
  (courseCleared)="courseCleared($event)"
></app-change-course-header>

<form [formGroup]="QuestionMaster">
  <div class="row pt-3" *ngIf="ShowSearch">
    <div class="col-9">
      <input
        type="text"
        class="form-control form-control-sm"
        placeholder="Keyword search"
        style="padding: 3px; width: 100%"
      />
    </div>
    <div class="col-2">
      <select
        class="form-control form-control-sm"
        formControlName="Keywordsearch"
        style="padding: 3px; width: 220px"
      >
        <option
          class="border-bottom"
          *ngFor="let s of getkeywordlist"
          [value]="s.Code"
        >
          {{ s.Description }}
        </option>
      </select>
    </div>
    <div class="col-2 pt-2">
      <select
        class="form-control form-control-sm"
        formControlName="CreatedBy"
        style="padding: 3px; width: 220px"
      >
        <option hidden selected value="null">Select Created By</option>
        <option
          class="border-bottom"
          *ngFor="let s of getCreatedby"
          [value]="s.Power_User_ID"
        >
          {{ s.Full_Name }}
        </option>
      </select>
    </div>
    <div class="col-2 pt-2">
      <select
        class="form-control form-control-sm"
        formControlName="ApprovedBy"
        style="padding: 3px; width: 220px"
      >
        <option hidden selected value="null">Select Apporved By</option>
        <option
          class="border-bottom"
          *ngFor="let s of getApprovedby"
          [value]="s.Power_User_ID"
        >
          {{ s.Full_Name }}
        </option>
      </select>
    </div>
    <div class="col-2 pt-2">
      <input
        type="text"
        formControlName="StartDate"
        placeholder="Select Created From"
        [owlDateTime]="dt1"
        [owlDateTimeTrigger]="dt1"
        class="form-control input-txt txtInput"
      />
      <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
    </div>
    <div class="col-2 pt-2">
      <input
        type="text"
        formControlName="EndDate"
        placeholder="Select Created To"
        [owlDateTime]="dt2"
        [owlDateTimeTrigger]="dt2"
        class="form-control input-txt txtInput"
      />
      <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
    </div>

    <div class="col-4 pt-2">
      <div class="form-check">
        <input type="checkbox" class="form-check-input" />
        <label class="form-check-label" for="exampleCheck1"
          >Limit Question Marked for No Translation</label
        >
      </div>
    </div>
    <div class="col-12 pt-2 ml-3">
      <div class="row d-flex">
        <div class="px-1">
          <button type="button" class="btn btn-sm bl-btn">Search</button>
        </div>
        <div class="px-1">
          <button type="button" class="btn btn-sm btn-light bg-light border">
            Clear
          </button>
        </div>
        <div class="px-1">
          <button
            type="button"
            class="btn btn-sm btn-light bg-light border"
            (click)="showsearch()"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
<div class="row">
  <div class="col-12">
    <div class="row border-bottom">
      <div class="col-2 py-2 p-1">
        <div class="p-0">
          <!-- style="min-width: 600px !important;max-width: 600px !important;" -->
          <select
            class="form-control form-control-sm"
            (change)="selectsubject($event)"
          >
            <option selected value="0" hidden>Select Subject</option>
            <option
              class="border-bottom"
              *ngFor="let s of subject; let i = index"
              [value]="s.ID"
            >
              {{ s.Name }}
            </option>
          </select>
        </div>
        <!-- <div class="px-1"  *ngIf="!ShowSearch">
          <button type="button" (click)="showsearch()" class="btn btn-sm bl-btn">Search</button>
        </div> -->
      </div>



      <div class="col-3 py-2 p-1" *ngIf="selectedsubject">
        <div class="d-flex">
          <div class="p-0">
            <button
              type="button"
              class="btn btn-sm py-0 px-1"
              (click)="RefreshActivity()"
            >
              <i
                class="fa1 fa fa-refresh"
                title="Refresh"
                aria-hidden="true"
              ></i>
            </button>
          </div>
          <div class="p-0">
            <button
              type="button"
              class="btn btn-sm py-0 px-1"
              (click)="SearchActivity()"
            >
              <i class="fa1 fa fa-search" title="Search" aria-hidden="true"></i>
            </button>
          </div>
          <div class="p-0 px-1">
            <button
              type="button"
              class="btn btn-sm bg-light border"
              (click)="openActivityHistory()"
            >
              Activity History
            </button>
          </div>
        </div>
      </div>
      <div class="col-2 py-2"></div>
      <div class="col-3 py-2"></div>

      <div class="col-2 py-2 p-1">
        <div class="row" *ngIf="selectedsubject">
          <div class="col-12">
            <div class="row">
              <!-- <div class="col-3 text-right pt-1 px-1">
                <div class="d-flex flex-row-reverse">
                <div class="p-0">Question No</div>
              </div>
              </div> -->
              <div class="col-2 p-1"></div>
              <div class="col-7 p-0">
                <input
                  type="text"
                  Placeholder="Enter Flash Card ID"
                  class="form-control form-control-sm"
                  [(ngModel)]="flashCardId"
                  (keyup.enter)="getFlashCardId()"
                />
              </div>
              <div class="col-3 px-1">
                <button
                  type="button"
                  class="btn btn-sm py-0 px-1"
                  (click)="getFlashCardId()"
                >
                  <i
                    class="fa1 fa fa-search"
                    title="Search Flash Card"
                    aria-hidden="true"
                  ></i>
                </button>
              </div>
              <!-- [disabled]="!SearchQuestionID" -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="row">
      <div class="col-12 px-1">
        <div class="row">
          <div
            class="col-12 scrollable-box"
            *ngIf="MajorTopic"

          >
            <!-- <div class="col-12" *ngIf="MajorTopic"> -->
            <div
              class="row tree-row"
              *ngFor="let MT of MajorTopic; let i = index"
              (mouseenter)="
                OnSelect(
                  MT.ID,
                  MT.Subject_Level_Type_Code,
                  MT.ChildNodeExistInd
                )
              "
            >
              <div class="col-12 d-flex">
                <div class="px-1 tree-btn-1">
                  <button
                    type="button"
                    class="tree-btn"
                    attr.id="plusMT{{ i }}"
                    [hidden]="MT.ChildNodeExistInd === 'N'"
                    (click)="getsubjectData(MT.ID, 'C', i)"
                  >
                    <i class="fa fa-angle-right" *ngIf="!MT.Data"></i
                    ><i class="fa fa-angle-down" *ngIf="MT.Data"></i>
                  </button>
                </div>
                <app-tree-content
                  Text="{{ MT.Name }}"
                  status="{{ MT.Status_Code }}"
                  ID="{{ MT.ID }}"
                  (mouseenter)="
                    OnSelect(
                      MT.ID,
                      MT.Subject_Level_Type_Code,
                      MT.ChildNodeExistInd
                    )
                  "
                ></app-tree-content>
                <div class="tree-Develop1" title="Total Count">
                  [&nbsp;{{ MT.Total_Count }}&nbsp;-&nbsp;Total&nbsp;]&nbsp;
                </div>
                <div
                  class="tree-Develop1"
                  *ngIf="MT.WIP_Count > 0"
                  title="WIP Count"
                >
                  [&nbsp;{{ MT.WIP_Count }}&nbsp;-&nbsp;WIP&nbsp;]&nbsp;
                </div>
                <div
                  class="tree-Develop1"
                  *ngIf="MT.Submitted_Count > 0"
                  title="Submitted Count"
                >
                  [&nbsp;{{
                    MT.Submitted_Count
                  }}&nbsp;-&nbsp;Submitted&nbsp;]&nbsp;
                </div>
                <div
                  class="tree-Develop1"
                  *ngIf="MT.Rework_Count > 0"
                  title="Rework Count"
                >
                  [&nbsp;{{ MT.Rework_Count }}&nbsp;-&nbsp;Rework&nbsp;]&nbsp;
                </div>
                <div
                  class="tree-Develop1"
                  *ngIf="MT.Approved_Count > 0"
                  title="Approved Count"
                >
                  [&nbsp;{{
                    MT.Approved_Count
                  }}&nbsp;-&nbsp;Approved&nbsp;]&nbsp;
                </div>
                <div
                  class="tree-Develop1"
                  *ngIf="MT.defer_Count > 0"
                  title="Defer Count"
                >
                  [&nbsp;{{ MT.defer_Count }}&nbsp;-&nbsp;Defer&nbsp;]&nbsp;
                </div>
                <div
                  class="tree-Develop1"
                  *ngIf="MT.Rejected_Count > 0"
                  title="Rejected Count"
                >
                  [&nbsp;{{
                    MT.Rejected_Count
                  }}&nbsp;-&nbsp;Rejected&nbsp;]&nbsp;
                </div>
                <div class="px-1 tree-btn-1" *ngIf="MT.Total_Count > 0">
                  <button
                    type="button"
                    attr.id="viewquestion{{ i }}"
                    class="tree-btn"
                    *ngIf="MT.ChildNodeExistInd === 'N'"
                    (click)="getQuestionlist(MT.ID)"
                  >
                    <i class="fa fa-bars" title="Flash Card List"></i>
                  </button>
                </div>
                <div class="px-1 tree-btn-1">
                  <button
                    type="button"
                    class="tree-btn"
                    (click)="AddQuestion(MT.ID)"
                    *ngIf="MT.ChildNodeExistInd === 'N'"
                    Text="Add Flash Card"
                  >
                    <i class="fa fa-plus" title="Add Flash Card"></i>
                  </button>
                </div>
                <div class="px-1 tree-btn-1" *ngIf="MT.Total_Count > 0">
                  <button
                    type="button"
                    attr.id="viewquestion{{ i }}"
                    class="tree-btn"
                    *ngIf="MT.ChildNodeExistInd === 'N'"
                    (click)="AssignFlashCard(+MT.ID)"
                  >
                  <img src="../../../../assets/images/link.png" alt="linkicon" style="vertical-align: baseline; width: 16px;" title="Assign Flashcard to Courses"/>
                  </button>
                </div>
                <div class="px-1 tree-btn-1" *ngIf="MT.Total_Count > 1">
                  <button
                    type="button"
                    attr.id="viewquestion{{ i }}"
                    class="tree-btn"
                    *ngIf="MT.ChildNodeExistInd === 'N'"
                    (click)="ShuffleQuestions(+MT.ID)"
                  >
                  <i class="fa fa-sort" aria-hidden="true" title="Shuffle Flash Card Display Order"></i>

                  </button>
                </div>
              </div>
              <div class="col-12" *ngIf="MT.Data">
                <div
                  class="row tree-row tree-row-child"
                  *ngFor="let C of MT.Data; let j = index"
                  (mouseenter)="
                    OnSelect(
                      C.ID,
                      C.Subject_Level_Type_Code,
                      C.ChildNodeExistInd
                    )
                  "
                >
                  <div class="col-12">
                    <div class="d-flex">
                      <div class="px-1 tree-btn-1">
                        <button
                          type="button"
                          class="tree-btn"
                          (click)="getsubjectData(C.ID, 'SC1', i, j)"
                          attr.id="plusC{{ i }}"
                          [hidden]="C.ChildNodeExistInd === 'N'"
                        >
                          <i class="fa fa-angle-right" *ngIf="!C.Data"></i
                          ><i class="fa fa-angle-down" *ngIf="C.Data"></i>
                        </button>
                      </div>
                      <app-tree-content
                        Text="{{ C.Name }}"
                        status="{{ C.Status_Code }}"
                        ID="{{ C.ID }}"
                        (mouseenter)="OnSelect(C.ID, 'C', C.ChildNodeExistInd)"
                      >
                      </app-tree-content>
                      <div class="tree-Develop1" title="Total Count">
                        [&nbsp;{{
                          C.Total_Count
                        }}&nbsp;-&nbsp;Total&nbsp;]&nbsp;
                      </div>
                      <div
                        class="tree-Develop1"
                        *ngIf="C.WIP_Count > 0"
                        title="WIP Count"
                      >
                        [&nbsp;{{ C.WIP_Count }}&nbsp;-&nbsp;WIP&nbsp;]&nbsp;
                      </div>
                      <div
                        class="tree-Develop1"
                        *ngIf="C.Submitted_Count > 0"
                        title="Submitted Count"
                      >
                        [&nbsp;{{
                          C.Submitted_Count
                        }}&nbsp;-&nbsp;Submitted&nbsp;]&nbsp;
                      </div>
                      <div
                        class="tree-Develop1"
                        *ngIf="C.Rework_Count > 0"
                        title="Rework Count"
                      >
                        [&nbsp;{{
                          C.Rework_Count
                        }}&nbsp;-&nbsp;Rework&nbsp;]&nbsp;
                      </div>
                      <div
                        class="tree-Develop1"
                        *ngIf="C.Approved_Count > 0"
                        title="Approved Count"
                      >
                        [&nbsp;{{
                          C.Approved_Count
                        }}&nbsp;-&nbsp;Approved&nbsp;]&nbsp;
                      </div>
                      <div
                        class="tree-Develop1"
                        *ngIf="C.defer_Count > 0"
                        title="Defer Count"
                      >
                        [&nbsp;{{
                          C.defer_Count
                        }}&nbsp;-&nbsp;Defer&nbsp;]&nbsp;
                      </div>
                      <div
                        class="tree-Develop1"
                        *ngIf="C.Rejected_Count > 0"
                        title="Rejected Count"
                      >
                        [&nbsp;{{
                          C.Rejected_Count
                        }}&nbsp;-&nbsp;Rejected&nbsp;]&nbsp;
                      </div>
                      <div class="px-1 tree-btn-1" *ngIf="C.Total_Count > 0">
                        <button
                          type="button"
                          attr.id="viewquestion{{ i }}"
                          class="tree-btn"
                          *ngIf="C.ChildNodeExistInd === 'N'"
                          (click)="getQuestionlist(C.ID)"
                        >
                          <i class="fa fa-bars" title="Flash Card List"></i>
                        </button>
                      </div>
                      <div class="px-1 tree-btn-1">
                        <button
                          type="button"
                          class="tree-btn"
                          (click)="AddQuestion(C.ID)"
                          *ngIf="C.ChildNodeExistInd === 'N'"
                          Text="Add Flash Card"
                        >
                          <i class="fa fa-plus" title="Add Flash Card"></i>
                        </button>
                      </div>
                      <div class="px-1 tree-btn-1" *ngIf="C.Total_Count > 0">
                        <button
                          type="button"
                          attr.id="viewquestion{{ i }}"
                          class="tree-btn"
                          *ngIf="C.ChildNodeExistInd === 'N'"
                          (click)="AssignFlashCard(C.ID)"
                        >
                          <!-- <i class="fa fa-archive" title="Assign Flashcard to Courses"></i> -->
                          <img src="../../../../assets/images/link.png" alt="linkicon" style="vertical-align: baseline; width: 16px;" title="Assign Flashcard to Courses"/>
                        </button>
                      </div>
                      <div class="px-1 tree-btn-1" *ngIf="C.Total_Count > 1">
                        <button
                          type="button"
                          attr.id="viewquestion{{ i }}"
                          class="tree-btn"
                          *ngIf="C.ChildNodeExistInd === 'N'"
                          (click)="ShuffleQuestions(C.ID)"
                        >
                        <i class="fa fa-sort" aria-hidden="true" title="Shuffle Flash Card Display Order"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12" *ngIf="C.Data">
                    <div
                      class="row tree-row tree-row-child"
                      *ngFor="let SC1 of C.Data; let k = index"
                      (mouseenter)="
                        OnSelect(
                          SC1.ID,
                          SC1.Subject_Level_Type_Code,
                          SC1.ChildNodeExistInd
                        )
                      "
                    >
                      <div class="col-12 d-flex">
                        <div class="px-1 tree-btn-1">
                          <button
                            type="button"
                            (click)="getsubjectData(SC1.ID, 'SC2', i, j, k)"
                            attr.id="plusSC1{{ i }}"
                            class="tree-btn"
                            [hidden]="SC1.ChildNodeExistInd === 'N'"
                          >
                            <i class="fa fa-angle-right" *ngIf="!SC1.Data"></i
                            ><i class="fa fa-angle-down" *ngIf="SC1.Data"></i>
                          </button>
                        </div>
                        <app-tree-content
                          Text="{{ SC1.Name }}"
                          status="{{ SC1.Status_Code }}"
                          ID="{{ SC1.ID }}"
                          (mouseenter)="
                            OnSelect(
                              SC1.ID,
                              SC1.Subject_Level_Type_Code,
                              SC1.ChildNodeExistInd
                            )
                          "
                        ></app-tree-content>
                        <div class="tree-Develop1" title="Total Count">
                          [&nbsp;{{
                            SC1.Total_Count
                          }}&nbsp;-&nbsp;Total&nbsp;]&nbsp;
                        </div>
                        <div
                          class="tree-Develop1"
                          *ngIf="SC1.WIP_Count > 0"
                          title="WIP Count"
                        >
                          [&nbsp;{{
                            SC1.WIP_Count
                          }}&nbsp;-&nbsp;WIP&nbsp;]&nbsp;
                        </div>
                        <div
                          class="tree-Develop1"
                          *ngIf="SC1.Submitted_Count > 0"
                          title="Submitted Count"
                        >
                          [&nbsp;{{
                            SC1.Submitted_Count
                          }}&nbsp;-&nbsp;Submitted&nbsp;]&nbsp;
                        </div>
                        <div
                          class="tree-Develop1"
                          *ngIf="SC1.Rework_Count > 0"
                          title="Rework Count"
                        >
                          [&nbsp;{{
                            SC1.Rework_Count
                          }}&nbsp;-&nbsp;Rework&nbsp;]&nbsp;
                        </div>
                        <div
                          class="tree-Develop1"
                          *ngIf="SC1.Approved_Count > 0"
                          title="Approved Count"
                        >
                          [&nbsp;{{
                            SC1.Approved_Count
                          }}&nbsp;-&nbsp;Approved&nbsp;]&nbsp;
                        </div>
                        <div
                          class="tree-Develop1"
                          *ngIf="SC1.defer_Count > 0"
                          title="Defer Count"
                        >
                          [&nbsp;{{
                            SC1.defer_Count
                          }}&nbsp;-&nbsp;Defer&nbsp;]&nbsp;
                        </div>
                        <div
                          class="tree-Develop1"
                          *ngIf="SC1.Rejected_Count > 0"
                          title="Rejected Count"
                        >
                          [&nbsp;{{
                            SC1.Rejected_Count
                          }}&nbsp;-&nbsp;Rejected&nbsp;]&nbsp;
                        </div>
                        <div
                          class="px-1 tree-btn-1"
                          *ngIf="SC1.Total_Count > 0"
                        >
                          <button
                            type="button"
                            attr.id="viewquestion{{ i }}"
                            class="tree-btn"
                            *ngIf="SC1.ChildNodeExistInd === 'N'"
                            (click)="getQuestionlist(SC1.ID)"
                          >
                            <i class="fa fa-bars" title="Flash Card List"></i>
                          </button>
                        </div>
                        <div class="px-1 tree-btn-1">
                          <button
                            type="button"
                            class="tree-btn"
                            (click)="AddQuestion(SC1.ID)"
                            *ngIf="SC1.ChildNodeExistInd === 'N'"
                            Text="Add Flash Card"
                          >
                            <i class="fa fa-plus" title="Add Flash Card"></i>
                          </button>
                        </div>
                        <div
                        class="px-1 tree-btn-1"
                        *ngIf="SC1.Total_Count > 0"
                      >
                        <button
                          type="button"
                          attr.id="viewquestion{{ i }}"
                          class="tree-btn"
                          *ngIf="SC1.ChildNodeExistInd === 'N'"
                          (click)="AssignFlashCard(SC1.ID)"
                        >
                          <!-- <i class="fa fa-archive" title="Assign Flashcard to Courses"></i> -->
                          <img src="../../../../assets/images/link.png" alt="linkicon" style="vertical-align: baseline; width: 16px;" title="Assign Flashcard to Courses"/>
                        </button>
                      </div>
                        <div
                        class="px-1 tree-btn-1"
                        *ngIf="SC1.Total_Count > 0"
                      >
                        <button
                          type="button"
                          attr.id="viewquestion{{ i }}"
                          class="tree-btn"
                          *ngIf="SC1.ChildNodeExistInd === 'N'"
                          (click)="ShuffleQuestions(SC1.ID)"
                        >
                        <i class="fa fa-sort" aria-hidden="true" title="Shuffle Flash Card Display Order"></i>

                        </button>
                      </div>
                      </div>
                      <div class="col-12" *ngIf="SC1.Data">
                        <div
                          class="row tree-row tree-row-child"
                          *ngFor="let SC2 of SC1.Data; let l = index"
                          (mouseenter)="
                            OnSelect(
                              SC2.ID,
                              SC2.Subject_Level_Type_Code,
                              SC2.ChildNodeExistInd
                            )
                          "
                        >
                          <div class="col-12 d-flex">
                            <div class="px-1 tree-btn-1">
                              <button
                                type="button"
                                class="tree-btn"
                                (click)="
                                  getsubjectData(SC2.ID, 'SC3', i, j, k, l)
                                "
                                attr.id="plusSC2{{ i }}"
                                [hidden]="SC2.ChildNodeExistInd === 'N'"
                              >
                                <i
                                  class="fa fa-angle-right"
                                  *ngIf="!SC2.Data"
                                ></i>
                                <i
                                  class="fa fa-angle-down"
                                  *ngIf="SC2.Data"
                                ></i>
                              </button>
                            </div>
                            <app-tree-content
                              Text="{{ SC2.Name }}"
                              status="{{ SC2.Status_Code }}"
                              ID="{{ SC2.ID }}"
                              (mouseenter)="
                                OnSelect(
                                  SC2.ID,
                                  SC2.Subject_Level_Type_Code,
                                  SC2.ChildNodeExistInd
                                )
                              "
                            >
                            </app-tree-content>
                            <div class="tree-Develop1" title="Total Count">
                              [&nbsp;{{
                                SC2.Total_Count
                              }}&nbsp;-&nbsp;Total&nbsp;]&nbsp;
                            </div>
                            <div
                              class="tree-Develop1"
                              *ngIf="SC2.WIP_Count > 0"
                              title="WIP Count"
                            >
                              [&nbsp;{{
                                SC2.WIP_Count
                              }}&nbsp;-&nbsp;WIP&nbsp;]&nbsp;
                            </div>
                            <div
                              class="tree-Develop1"
                              *ngIf="SC2.Submitted_Count > 0"
                              title="Submitted Count"
                            >
                              [&nbsp;{{
                                SC2.Submitted_Count
                              }}&nbsp;-&nbsp;Submitted&nbsp;]&nbsp;
                            </div>
                            <div
                              class="tree-Develop1"
                              *ngIf="SC2.Rework_Count > 0"
                              title="Rework Count"
                            >
                              [&nbsp;{{
                                SC2.Rework_Count
                              }}&nbsp;-&nbsp;Rework&nbsp;]&nbsp;
                            </div>
                            <div
                              class="tree-Develop1"
                              *ngIf="SC2.Approved_Count > 0"
                              title="Approved Count"
                            >
                              [&nbsp;{{
                                SC2.Approved_Count
                              }}&nbsp;-&nbsp;Approved&nbsp;]&nbsp;
                            </div>
                            <div
                              class="tree-Develop1"
                              *ngIf="SC2.defer_Count > 0"
                              title="Defer Count"
                            >
                              [&nbsp;{{
                                SC2.defer_Count
                              }}&nbsp;-&nbsp;Defer&nbsp;]&nbsp;
                            </div>
                            <div
                              class="tree-Develop1"
                              *ngIf="SC2.Rejected_Count > 0"
                              title="Rejected Count"
                            >
                              [&nbsp;{{
                                SC2.Rejected_Count
                              }}&nbsp;-&nbsp;Rejected&nbsp;]&nbsp;
                            </div>
                            <div
                              class="px-1 tree-btn-1"
                              *ngIf="SC2.Total_Count > 0"
                            >
                              <button
                                type="button"
                                attr.id="viewquestion{{ i }}"
                                class="tree-btn"
                                *ngIf="SC2.ChildNodeExistInd === 'N'"
                                (click)="getQuestionlist(SC2.ID)"
                              >
                                <i
                                  class="fa fa-bars"
                                  title="Flash Card List"
                                ></i>
                              </button>
                            </div>
                            <div class="px-1 tree-btn-1">
                              <button
                                type="button"
                                class="tree-btn"
                                (click)="AddQuestion(SC2.ID)"
                                *ngIf="SC2.ChildNodeExistInd === 'N'"
                                Text="Add Flash Card"
                              >
                                <i class="fa fa-plus" title="Add Flash Card"></i>
                              </button>
                            </div>
                            <div
                            class="px-1 tree-btn-1"
                            *ngIf="SC2.Total_Count > 0"
                          >
                            <button
                              type="button"
                              attr.id="viewquestion{{ i }}"
                              class="tree-btn"
                              *ngIf="SC2.ChildNodeExistInd === 'N'"
                              (click)="AssignFlashCard(SC2.ID)"
                            >
                            <img src="../../../../assets/images/link.png" alt="linkicon" style="vertical-align: baseline; width: 16px;" title="Assign Flashcard to Courses"/>

                            </button>
                          </div>
                            <div
                            class="px-1 tree-btn-1"
                            *ngIf="SC2.Total_Count > 1"
                          >
                            <button
                              type="button"
                              attr.id="viewquestion{{ i }}"
                              class="tree-btn"
                              *ngIf="SC2.ChildNodeExistInd === 'N'"
                              (click)="ShuffleQuestions(SC2.ID)"
                            >
                            <i class="fa fa-sort" aria-hidden="true" title="Shuffle Flash Card Display Order"></i>

                            </button>
                          </div>
                          </div>
                          <div class="col-12" *ngIf="SC2.Data">
                            <div
                              class="row tree-row tree-row-child"
                              *ngFor="let SC3 of SC2.Data; let m = index"
                              (mouseenter)="
                                OnSelect(
                                  SC3.ID,
                                  SC3.Subject_Level_Type_Code,
                                  SC3.ChildNodeExistInd
                                )
                              "
                            >
                              <div class="col-12 d-flex">
                                <div class="px-1 tree-btn-1">
                                  <button
                                    type="button"
                                    class="tree-btn"
                                    (click)="
                                      getsubjectData(
                                        SC3.ID,
                                        'SC4',
                                        i,
                                        j,
                                        k,
                                        l,
                                        m
                                      )
                                    "
                                    attr.id="plusSC3{{ i }}"
                                    [hidden]="SC3.ChildNodeExistInd === 'N'"
                                  >
                                    <i
                                      class="fa fa-angle-right"
                                      *ngIf="!SC3.Data"
                                    ></i>
                                    <i
                                      class="fa fa-angle-down"
                                      *ngIf="SC3.Data"
                                    ></i>
                                  </button>
                                </div>
                                <app-tree-content
                                  Text="{{ SC3.Name }}"
                                  status="{{ SC3.Status_Code }}"
                                  ID="{{ SC3.ID }}"
                                  (mouseenter)="
                                    OnSelect(
                                      SC3.ID,
                                      SC3.Subject_Level_Type_Code,
                                      SC3.ChildNodeExistInd
                                    )
                                  "
                                >
                                </app-tree-content>
                                <div class="tree-Develop1" title="Total Count">
                                  [&nbsp;{{
                                    SC3.Total_Count
                                  }}&nbsp;-&nbsp;Total&nbsp;]&nbsp;
                                </div>
                                <div
                                  class="tree-Develop1"
                                  *ngIf="SC3.WIP_Count > 0"
                                  title="WIP Count"
                                >
                                  [&nbsp;{{
                                    SC3.WIP_Count
                                  }}&nbsp;-&nbsp;WIP&nbsp;]&nbsp;
                                </div>
                                <div
                                  class="tree-Develop1"
                                  *ngIf="SC3.Submitted_Count > 0"
                                  title="Submitted Count"
                                >
                                  [&nbsp;{{
                                    SC3.Submitted_Count
                                  }}&nbsp;-&nbsp;Submitted&nbsp;]&nbsp;
                                </div>
                                <div
                                  class="tree-Develop1"
                                  *ngIf="SC3.Rework_Count > 0"
                                  title="Rework Count"
                                >
                                  [&nbsp;{{
                                    SC3.Rework_Count
                                  }}&nbsp;-&nbsp;Rework&nbsp;]&nbsp;
                                </div>
                                <div
                                  class="tree-Develop1"
                                  *ngIf="SC3.Approved_Count > 0"
                                  title="Approved Count"
                                >
                                  [&nbsp;{{
                                    SC3.Approved_Count
                                  }}&nbsp;-&nbsp;Approved&nbsp;]&nbsp;
                                </div>
                                <div
                                  class="tree-Develop1"
                                  *ngIf="SC3.defer_Count > 0"
                                  title="Defer Count"
                                >
                                  [&nbsp;{{
                                    SC3.defer_Count
                                  }}&nbsp;-&nbsp;Defer&nbsp;]&nbsp;
                                </div>
                                <div
                                  class="tree-Develop1"
                                  *ngIf="SC3.Rejected_Count > 0"
                                  title="Rejected Count"
                                >
                                  [&nbsp;{{
                                    SC3.Rejected_Count
                                  }}&nbsp;-&nbsp;Rejected&nbsp;]&nbsp;
                                </div>
                                <div
                                  class="px-1 tree-btn-1"
                                  *ngIf="SC3.Total_Count > 0"
                                >
                                  <button
                                    type="button"
                                    attr.id="viewquestion{{ i }}"
                                    class="tree-btn"
                                    *ngIf="SC3.ChildNodeExistInd === 'N'"
                                    (click)="getQuestionlist(SC3.ID)"
                                  >
                                    <i
                                      class="fa fa-bars"
                                      title="Flash Card List"
                                    ></i>
                                  </button>
                                </div>
                                <div class="px-1 tree-btn-1">
                                  <button
                                    type="button"
                                    class="tree-btn"
                                    (click)="AddQuestion(SC3.ID)"
                                    *ngIf="SC3.ChildNodeExistInd === 'N'"
                                    Text="Add Flash Card"
                                  >
                                    <i
                                      class="fa fa-plus"
                                      title="Add Flash Card"
                                    ></i>
                                  </button>
                                </div>
                                <div
                                class="px-1 tree-btn-1"
                                *ngIf="SC3.Total_Count > 0"
                              >
                                <button
                                  type="button"
                                  attr.id="viewquestion{{ i }}"
                                  class="tree-btn"
                                  *ngIf="SC3.ChildNodeExistInd === 'N'"
                                  (click)="AssignFlashCard(SC3.ID)"

                                >
                                <img src="../../../../assets/images/link.png" alt="linkicon" style="vertical-align: baseline; width: 16px;" title="Assign Flashcard to Courses"/>
                                </button>
                              </div>
                                <div
                                class="px-1 tree-btn-1"
                                *ngIf="SC3.Total_Count > 1"
                              >
                                <button
                                  type="button"
                                  attr.id="viewquestion{{ i }}"
                                  class="tree-btn"
                                  *ngIf="SC3.ChildNodeExistInd === 'N'"
                                  (click)="ShuffleQuestions(SC3.ID)"

                                >
                                <i class="fa fa-sort" aria-hidden="true" title="Shuffle Flash Card Display Order"></i>

                                </button>
                              </div>
                              </div>
                              <div class="col-12" *ngIf="SC3.Data">
                                <div
                                  class="row tree-row tree-row-child"
                                  *ngFor="let SC4 of SC3.Data; let n = index"
                                  (mouseenter)="
                                    OnSelect(
                                      SC4.ID,
                                      SC4.Subject_Level_Type_Code,
                                      SC4.ChildNodeExistInd
                                    )
                                  "
                                >
                                  <div class="col-12 d-flex">
                                    <div class="px-1 tree-btn-1">
                                      <button
                                        type="button"
                                        class="tree-btn"
                                        (click)="
                                          getsubjectData(
                                            SC4.ID,
                                            'SC5',
                                            i,
                                            j,
                                            k,
                                            l,
                                            m,
                                            n
                                          )
                                        "
                                        [hidden]="SC4.ChildNodeExistInd === 'N'"
                                      >
                                        <i
                                          class="fa fa-angle-right"
                                          *ngIf="!SC4.Data"
                                        ></i>
                                        <i
                                          class="fa fa-angle-down"
                                          *ngIf="SC4.Data"
                                        ></i>
                                      </button>
                                    </div>
                                    <app-tree-content
                                      Text="{{ SC4.Name }}"
                                      status="{{ SC4.Status_Code }}"
                                      ID="{{ SC4.ID }}"
                                      (mouseenter)="
                                        OnSelect(
                                          SC4.ID,
                                          SC4.Subject_Level_Type_Code,
                                          SC4.ChildNodeExistInd
                                        )
                                      "
                                    ></app-tree-content>
                                    <div
                                      class="tree-Develop1"
                                      title="Total Count"
                                    >
                                      [&nbsp;{{
                                        SC4.Total_Count
                                      }}&nbsp;-&nbsp;Total&nbsp;]&nbsp;
                                    </div>
                                    <div
                                      class="tree-Develop1"
                                      *ngIf="SC4.WIP_Count > 0"
                                      title="WIP Count"
                                    >
                                      [&nbsp;{{
                                        SC4.WIP_Count
                                      }}&nbsp;-&nbsp;WIP&nbsp;]&nbsp;
                                    </div>
                                    <div
                                      class="tree-Develop1"
                                      *ngIf="SC4.Submitted_Count > 0"
                                      title="Submitted Count"
                                    >
                                      [&nbsp;{{
                                        SC4.Submitted_Count
                                      }}&nbsp;-&nbsp;Submitted&nbsp;]&nbsp;
                                    </div>
                                    <div
                                      class="tree-Develop1"
                                      *ngIf="SC4.Rework_Count > 0"
                                      title="Rework Count"
                                    >
                                      [&nbsp;{{
                                        SC4.Rework_Count
                                      }}&nbsp;-&nbsp;Rework&nbsp;]&nbsp;
                                    </div>
                                    <div
                                      class="tree-Develop1"
                                      *ngIf="SC4.Approved_Count > 0"
                                      title="Approved Count"
                                    >
                                      [&nbsp;{{
                                        SC4.Approved_Count
                                      }}&nbsp;-&nbsp;Approved&nbsp;]&nbsp;
                                    </div>
                                    <div
                                      class="tree-Develop1"
                                      *ngIf="SC4.defer_Count > 0"
                                      title="Defer Count"
                                    >
                                      [&nbsp;{{
                                        SC4.defer_Count
                                      }}&nbsp;-&nbsp;Defer&nbsp;]&nbsp;
                                    </div>
                                    <div
                                      class="tree-Develop1"
                                      *ngIf="SC4.Rejected_Count > 0"
                                      title="Rejected Count"
                                    >
                                      [&nbsp;{{
                                        SC4.Rejected_Count
                                      }}&nbsp;-&nbsp;Rejected&nbsp;]&nbsp;
                                    </div>
                                    <div
                                      class="px-1 tree-btn-1"
                                      *ngIf="SC4.Total_Count > 0"
                                    >
                                      <button
                                        type="button"
                                        attr.id="viewquestion{{ i }}"
                                        class="tree-btn"
                                        *ngIf="SC4.ChildNodeExistInd === 'N'"
                                        (click)="getQuestionlist(SC4.ID)"
                                      >
                                        <i
                                          class="fa fa-bars"
                                          title="Flash Card List"
                                        ></i>
                                      </button>
                                    </div>
                                    <div class="px-1 tree-btn-1">
                                      <button
                                        type="button"
                                        class="tree-btn"
                                        (click)="AddQuestion(SC4.ID)"
                                        *ngIf="SC4.ChildNodeExistInd === 'N'"
                                        Text="Add Flash Card"
                                      >
                                        <i
                                          class="fa fa-plus"
                                          title="Add Flash Card"
                                        ></i>
                                      </button>
                                    </div>
                                    <div
                                    class="px-1 tree-btn-1"
                                    *ngIf="SC4.Total_Count > 0"
                                  >
                                    <button
                                      type="button"
                                      attr.id="viewquestion{{ i }}"
                                      class="tree-btn"
                                      *ngIf="SC4.ChildNodeExistInd === 'N'"
                                      (click)="AssignFlashCard(SC4.ID)"
                                    >
                                    <img src="../../../../assets/images/link.png" alt="linkicon" style="vertical-align: baseline; width: 16px;" title="Assign Flashcard to Courses"/>
                                    </button>
                                  </div>
                                    <div
                                    class="px-1 tree-btn-1"
                                    *ngIf="SC4.Total_Count > 0"
                                  >
                                    <button
                                      type="button"
                                      attr.id="viewquestion{{ i }}"
                                      class="tree-btn"
                                      *ngIf="SC4.ChildNodeExistInd === 'N'"
                                      (click)="ShuffleQuestions(SC4.ID)"
                                    >
                                    <i class="fa fa-sort" aria-hidden="true" title="Shuffle Flash Card Display Order"></i>
                                    </button>
                                  </div>
                                  </div>
                                  <div class="col-12" *ngIf="SC4.Data">
                                    <div
                                      class="row tree-row tree-row-child"
                                      *ngFor="
                                        let SC5 of SC4.Data;
                                        let o = index
                                      "
                                      (mouseenter)="
                                        OnSelect(
                                          SC5.ID,
                                          SC5.Subject_Level_Type_Code,
                                          SC5.ChildNodeExistInd
                                        )
                                      "
                                    >
                                      <div class="col-12 d-flex">
                                        <div class="px-1 tree-btn-1">
                                          <button
                                            type="button"
                                            class="tree-btn"
                                            (click)="
                                              getsubjectData(
                                                SC5.ID,
                                                'SC6',
                                                i,
                                                j,
                                                k,
                                                l,
                                                m,
                                                n,
                                                o
                                              )
                                            "
                                            [hidden]="
                                              SC5.ChildNodeExistInd === 'N'
                                            "
                                          >
                                            <i
                                              class="fa fa-angle-right"
                                              *ngIf="!SC5.Data"
                                            ></i>
                                            <i
                                              class="fa fa-angle-down"
                                              *ngIf="SC5.Data"
                                            ></i>
                                          </button>
                                        </div>
                                        <app-tree-content
                                          Text="{{ SC5.Name }}"
                                          status="{{ SC5.Status_Code }}"
                                          ID="{{ SC5.ID }}"
                                          (mouseenter)="
                                            OnSelect(
                                              SC5.ID,
                                              SC5.Subject_Level_Type_Code,
                                              SC5.ChildNodeExistInd
                                            )
                                          "
                                        ></app-tree-content>
                                        <div
                                          class="tree-Develop1"
                                          title="Total Count"
                                        >
                                          [&nbsp;{{
                                            SC5.Total_Count
                                          }}&nbsp;-&nbsp;Total&nbsp;]&nbsp;
                                        </div>
                                        <div
                                          class="tree-Develop1"
                                          *ngIf="SC5.WIP_Count > 0"
                                          title="WIP Count"
                                        >
                                          [&nbsp;{{
                                            SC5.WIP_Count
                                          }}&nbsp;-&nbsp;WIP&nbsp;]&nbsp;
                                        </div>
                                        <div
                                          class="tree-Develop1"
                                          *ngIf="SC5.Submitted_Count > 0"
                                          title="Submitted Count"
                                        >
                                          [&nbsp;{{
                                            SC5.Submitted_Count
                                          }}&nbsp;-&nbsp;Submitted&nbsp;]&nbsp;
                                        </div>
                                        <div
                                          class="tree-Develop1"
                                          *ngIf="SC5.Rework_Count > 0"
                                          title="Rework Count"
                                        >
                                          [&nbsp;{{
                                            SC5.Rework_Count
                                          }}&nbsp;-&nbsp;Rework&nbsp;]&nbsp;
                                        </div>
                                        <div
                                          class="tree-Develop1"
                                          *ngIf="SC5.Approved_Count > 0"
                                          title="Approved Count"
                                        >
                                          [&nbsp;{{
                                            SC5.Approved_Count
                                          }}&nbsp;-&nbsp;Approved&nbsp;]&nbsp;
                                        </div>
                                        <div
                                          class="tree-Develop1"
                                          *ngIf="SC5.defer_Count > 0"
                                          title="Defer Count"
                                        >
                                          [&nbsp;{{
                                            SC5.defer_Count
                                          }}&nbsp;-&nbsp;Defer&nbsp;]&nbsp;
                                        </div>
                                        <div
                                          class="tree-Develop1"
                                          *ngIf="SC5.Rejected_Count > 0"
                                          title="Rejected Count"
                                        >
                                          [&nbsp;{{
                                            SC5.Rejected_Count
                                          }}&nbsp;-&nbsp;Rejected&nbsp;]&nbsp;
                                        </div>
                                        <div
                                          class="px-1 tree-btn-1"
                                          *ngIf="SC5.Total_Count > 0"
                                        >
                                          <button
                                            type="button"
                                            attr.id="viewquestion{{ i }}"
                                            class="tree-btn"
                                            *ngIf="
                                              SC5.ChildNodeExistInd === 'N'
                                            "
                                            (click)="getQuestionlist(SC5.ID)"
                                          >
                                            <i
                                              class="fa fa-bars"
                                              title="Flash Card List"
                                            ></i>
                                          </button>
                                        </div>
                                        <div class="px-1 tree-btn-1">
                                          <button
                                            type="button"
                                            class="tree-btn"
                                            (click)="AddQuestion(SC5.ID)"
                                            *ngIf="
                                              SC5.ChildNodeExistInd === 'N'
                                            "
                                            Text="Add Flash Card"
                                          >
                                            <i
                                              class="fa fa-plus"
                                              title="Add Flash Card"
                                            ></i>
                                          </button>
                                        </div>
                                        <div
                                        class="px-1 tree-btn-1"
                                        *ngIf="SC5.Total_Count > 0"
                                      >
                                        <button
                                          type="button"
                                          attr.id="viewquestion{{ i }}"
                                          class="tree-btn"
                                          *ngIf="
                                            SC5.ChildNodeExistInd === 'N'
                                          "
                                          (click)="AssignFlashCard(SC5.ID)"
                                        >
                                        <img src="../../../../assets/images/link.png" alt="linkicon" style="vertical-align: baseline; width: 16px;" title="Assign Flashcard to Courses"/>
                                        </button>
                                      </div>
                                        <div
                                        class="px-1 tree-btn-1"
                                        *ngIf="SC5.Total_Count > 0"
                                      >
                                        <button
                                          type="button"
                                          attr.id="viewquestion{{ i }}"
                                          class="tree-btn"
                                          *ngIf="
                                            SC5.ChildNodeExistInd === 'N'
                                          "
                                          (click)="ShuffleQuestions(SC5.ID)"
                                        >
                                        <i class="fa fa-sort" aria-hidden="true" title="Shuffle Flash Card Display Order"></i>
                                        </button>
                                      </div>
                                      </div>
                                      <div class="col-12" *ngIf="SC5.Data">
                                        <div
                                          class="row tree-row tree-row-child"
                                          *ngFor="
                                            let SC6 of SC5.Data;
                                            let p = index
                                          "
                                          (mouseenter)="
                                            OnSelect(
                                              SC6.ID,
                                              SC6.Subject_Level_Type_Code,
                                              SC6.ChildNodeExistInd
                                            )
                                          "
                                        >
                                          <div class="col-12 d-flex">
                                            <div class="px-1 tree-btn-1">
                                              <button
                                                type="button"
                                                class="tree-btn"
                                                [hidden]="
                                                  SC6.ChildNodeExistInd === 'N'
                                                "
                                              >
                                                <i
                                                  class="fa fa-angle-right"
                                                  *ngIf="!SC6.Data"
                                                ></i>
                                                <i
                                                  class="fa fa-angle-down"
                                                  *ngIf="SC6.Data"
                                                ></i>
                                              </button>
                                            </div>
                                            <app-tree-content
                                              Text="{{ SC6.Name }}"
                                              status="{{ SC6.Status_Code }}"
                                              ID="{{ SC6.ID }}"
                                              (mouseenter)="
                                                OnSelect(
                                                  SC6.ID,
                                                  SC6.Subject_Level_Type_Code,
                                                  SC6.ChildNodeExistInd
                                                )
                                              "
                                            >
                                            </app-tree-content>
                                            <div
                                              class="tree-Develop1"
                                              title="Total Count"
                                            >
                                              [&nbsp;{{
                                                SC6.Total_Count
                                              }}&nbsp;-&nbsp;Total&nbsp;]&nbsp;
                                            </div>
                                            <div
                                              class="tree-Develop1"
                                              *ngIf="SC6.WIP_Count > 0"
                                              title="WIP Count"
                                            >
                                              [&nbsp;{{
                                                SC6.WIP_Count
                                              }}&nbsp;-&nbsp;WIP&nbsp;]&nbsp;
                                            </div>
                                            <div
                                              class="tree-Develop1"
                                              *ngIf="SC6.Submitted_Count > 0"
                                              title="Submitted Count"
                                            >
                                              [&nbsp;{{
                                                SC6.Submitted_Count
                                              }}&nbsp;-&nbsp;Submitted&nbsp;]&nbsp;
                                            </div>
                                            <div
                                              class="tree-Develop1"
                                              *ngIf="SC6.Rework_Count > 0"
                                              title="Rework Count"
                                            >
                                              [&nbsp;{{
                                                SC6.Rework_Count
                                              }}&nbsp;-&nbsp;Rework&nbsp;]&nbsp;
                                            </div>
                                            <div
                                              class="tree-Develop1"
                                              *ngIf="SC6.Approved_Count > 0"
                                              title="Approved Count"
                                            >
                                              [&nbsp;{{
                                                SC6.Approved_Count
                                              }}&nbsp;-&nbsp;Approved&nbsp;]&nbsp;
                                            </div>
                                            <div
                                              class="tree-Develop1"
                                              *ngIf="SC6.defer_Count > 0"
                                              title="Defer Count"
                                            >
                                              [&nbsp;{{
                                                SC6.defer_Count
                                              }}&nbsp;-&nbsp;Defer&nbsp;]&nbsp;
                                            </div>
                                            <div
                                              class="tree-Develop1"
                                              *ngIf="SC6.Rejected_Count > 0"
                                              title="Rejected Count"
                                            >
                                              [&nbsp;{{
                                                SC6.Rejected_Count
                                              }}&nbsp;-&nbsp;Rejected&nbsp;]&nbsp;
                                            </div>
                                            <div
                                              class="px-1 tree-btn-1"
                                              *ngIf="SC6.Total_Count > 0"
                                            >
                                              <button
                                                type="button"
                                                attr.id="viewquestion{{ i }}"
                                                class="tree-btn"
                                                *ngIf="
                                                  SC6.ChildNodeExistInd === 'N'
                                                "
                                                (click)="
                                                  getQuestionlist(SC6.ID)
                                                "
                                              >
                                                <i
                                                  class="fa fa-bars"
                                                  title="Flash Card List"
                                                ></i>
                                              </button>
                                            </div>
                                            <div class="px-1 tree-btn-1">
                                              <button
                                                type="button"
                                                class="tree-btn"
                                                (click)="AddQuestion(SC6.ID)"
                                                *ngIf="
                                                  SC6.ChildNodeExistInd === 'N'
                                                "
                                                Text="Add Flash Card"
                                              >
                                                <i
                                                  class="fa fa-plus"
                                                  title="Add Flash Card"
                                                ></i>
                                              </button>
                                            </div>
                                            <div
                                            class="px-1 tree-btn-1"
                                            *ngIf="SC6.Total_Count > 0"
                                          >
                                            <button
                                              type="button"
                                              attr.id="viewquestion{{ i }}"
                                              class="tree-btn"
                                              *ngIf="
                                                SC6.ChildNodeExistInd === 'N'
                                              "
                                (click)="AssignFlashCard(SC6.ID)"
                                            >
                                            <img src="../../../../assets/images/link.png" alt="linkicon" style="vertical-align: baseline; width: 16px;" title="Assign Flashcard to Courses"/>

                                            </button>
                                          </div>
                                            <div
                                            class="px-1 tree-btn-1"
                                            *ngIf="SC6.Total_Count > 1"
                                          >
                                            <button
                                              type="button"
                                              attr.id="viewquestion{{ i }}"
                                              class="tree-btn"
                                              *ngIf="
                                                SC6.ChildNodeExistInd === 'N'
                                              "
                                (click)="ShuffleQuestions(SC6.ID)"
                                            >
                                            <i class="fa fa-sort" aria-hidden="true" title="Shuffle Flash Card Display Order"></i>

                                            </button>
                                          </div>
                                          </div>
                                          <!-- <div class="col-12"
                                              *ngIf="SC6.ChildNodeExistInd === 'N' && enableedit && selectedvalue==SC6.ID && (selectedkey === 'SCL6' || selectedkey === 'SCL6') && ScreenName=='SUBJECT BREAKDOWN'">
                                              <app-tree-add-btn-child (click)="AddQuestion(SC6.ID)"
                                                *ngIf="enableedit && selectedvalue == SC6.ID && (selectedkey === 'SCL6' || selectedkey === 'SCL6')"
                                                (mouseenter)="OnSelect(SC6.ID,'SCL6',SC6.ChildNodeExistInd)" Text="Add Flashcard" [Primary]=0>
                                              </app-tree-add-btn-child>



                                            </div> -->
                                          <div class="col-12">
                                            <!-- <app-question-list *ngIf="SC6.ChildNodeExistInd === 'N' && selectedlist==SC6.ID" [questionsubjectresponse]="questionsubjectresponse" [ScreenName1]="ScreenName1" (RefreshEditQuestion)="RefreshEditQuestion($event)" [Questionlistresponse]="Questionlistresponse" [subjectById]="subjectById"></app-question-list> -->
                                          </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>


            </div>

          </div>
        </div>
      </div>

    </div>

  </div>
</div>
<div class="modal fade show Model_popup1" *ngIf="selectQuestionTemplate">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">
          Select Question Template
        </h6>
        <button
          type="button"
          class="close"
          (click)="QuestionTemplateType()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-fa-question-selection-template
          [subjectById]="subjectById"
          (ClickNextButton)="ClickNextButton($event)"
        ></app-fa-question-selection-template>
      </div>
    </div>
  </div>
</div>
<div class="modal fade show Model_popup1" style="z-index:1080" *ngIf="NextButtonflag">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
    <div class="modal-content" style="height: 93vh; overflow-y: scroll">
      <div
        class="modal-header border Page-Header p-1 py-0"
        style="position: sticky; top: 0px; z-index: 999; background: #f0f0f0"
      >
        <h6 class="HeadContent" id="QuestionTemplatetitle">
          Admin: Flash Cards: Add/Edit Flash Card
        </h6>

        <button
          type="button"
          class="close"
          (click)="closeEventTrigger()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body px-3 py-0">
        <!-- <app-fa-question-add-edit
          [redirect]="redirect"
          [ScreenName1]="ScreenName1"
          (ClickQuestionBody)="ClickQuestionBody($event)"
          (EmitAnswerChoiceDetails)="EmitAnswerChoiceDetails($event)"
          (EmitpreviewDetails)="EmitpreviewDetails($event)"
          [NextButtonflag]="NextButtonflag"
          [selectedQuestionList]="selectedQuestionList"
          [subjectById]="subjectById"
          (OpenEditQuestion)="OpenEditQuestion($event)"
          (AddQuestionHeaderClose)="AddQuestionHeaderClose($event)"
          (ClickQuestionPreview)="ClickQuestionPreview($event)"
          (EditAnswerNote)="EditAnswerNote($event)"
          (EditSolutionHint)="EditSolutionHint($event)"
          (ClickAnswerChoice)="ClickAnswerChoice($event)"
          (ClickQuestionstatus)="ClickQuestionstatus($event)"
          (ClickQuestionStatusPopup)="ClickQuestionStatusPopup($event)"
          [selectedQuestionById]="selectedQuestionById"
        ></app-fa-question-add-edit> -->
        <app-fa-question-add-edit
          [subjectById]="subjectById"
          (closeFaDialog)="closeFaDialog($event)"
          [flashCardId]="flashCardIdMatched"
          [globalFlashCardList]="globalSubjectId"
          [closeEventTriggerFa]="closeTriggerValue"
        ></app-fa-question-add-edit>
      </div>
    </div>
    <!-- (ClickQuestionstatus)="ClickQuestionstatus($event)"
      (ClickQuestionStatusPopup)="ClickQuestionStatusPopup($event)"
      (AddQuestionHeaderClose)="AddQuestionHeaderClose($event)"
      (ClickQuestionPreview)="ClickQuestionPreview($event)"
          (EditAnswerNote)="EditAnswerNote($event)"
          (ClickAnswerChoice)="ClickAnswerChoice($event)"
          (ClickQuestionBody)="ClickQuestionBody($event)" -->
  </div>
</div>
<div class="modal fade show Model_popup1" *ngIf="false">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">
          Add/Edit Question
        </h6>
        <button
          type="button"
          class="close"
          (click)="AddQuestionpopup()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-fa-question-body-add-edit
          (Questionrefreshpreview)="Questionrefreshpreview($event)"
          (REdirectPreview)="REdirectPreview($event)"
          (AddREdirecttoRightAnswer)="AddREdirecttoRightAnswer($event)"
          [selectedQuestionList]="selectedQuestionList"
          [QuestionBodyPopup]="QuestionBodyPopup"
          [subjectById]="subjectById"
          [selectedQuestionById]="selectedQuestionById"
          (AddQuestionBodyclose)="AddQuestionBodyclose($event)"
        ></app-fa-question-body-add-edit>
      </div>
    </div>
  </div>
</div>

<div class="modal fade show Model_popup1" *ngIf="AnswerChoicePopup">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">
          Add Answer Choice
        </h6>
        <button
          type="button"
          class="close"
          (click)="AddQuestionpopup()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-fa-answer-choice-add-edit
          (ClickAddsolutionHint)="ClickAddsolutionHint($event)"
          (ClickAnswerChoiceNoteBody)="ClickAnswerChoiceNoteBody($event)"
          (AddAnswerchoiceclose)="AddAnswerchoiceclose($event)"
          [AnswerChoicePopup]="AnswerChoicePopup"
          [selectedQuestionById]="selectedQuestionById"
          [subjectById]="subjectById"
          [Answerflag]="Answerflag"
        ></app-fa-answer-choice-add-edit>
      </div>
    </div>
  </div>
</div>
<div class="modal fade show Model_popup1" *ngIf="AnswerChoiceNotePopup">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">
          Add Answer Choice Note
        </h6>
        <button
          type="button"
          class="close"
          (click)="AddQuestionpopup()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-fa-answer-choice-note
          (AddAnswerchoiceNoteclose)="AddAnswerchoiceNoteclose($event)"
          [AnswerChoiceNotePopup]="AnswerChoiceNotePopup"
          [selectedQuestionById]="selectedQuestionById"
        ></app-fa-answer-choice-note>
      </div>
    </div>
  </div>
</div>
<div class="modal fade show Model_popup1" *ngIf="Addsolutionhintpopup">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">
          Add Solution Hint
        </h6>
        <button
          type="button"
          class="close"
          (click)="AddQuestionpopup()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <!-- <app-fa-answer-choice-note (AddAnswerchoiceNoteclose)="AddAnswerchoiceNoteclose($event)" [AnswerChoiceNotePopup]="AnswerChoiceNotePopup" [selectedQuestionById]="selectedQuestionById"></app-fa-answer-choice-note> -->
        <app-fa-answer-choice-solution-hint
          (AddSolutionHintclose)="AddSolutionHintclose($event)"
          [Addsolutionhintpopup]="Addsolutionhintpopup"
          [selectedQuestionById]="selectedQuestionById"
        ></app-fa-answer-choice-solution-hint>
      </div>
    </div>
  </div>
</div>
<div class="modal fade show Model_popup1" *ngIf="EditAnswerChoiceNotePopup">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">
          Edit Answer Choice Note
        </h6>
        <button
          type="button"
          class="close"
          (click)="AddQuestionpopup()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-fa-answer-choice-note
          (EditAddAnswerchoiceNoteclose)="EditAddAnswerchoiceNoteclose($event)"
          [EditAnswerChoiceNotePopup]="EditAnswerChoiceNotePopup"
          [selectedQuestionById]="selectedQuestionById"
        ></app-fa-answer-choice-note>
      </div>
    </div>
  </div>
</div>
<div class="modal fade show Model_popup1" *ngIf="EditSolutionHintPopup">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">
          Edit Solution Hint
        </h6>
        <button
          type="button"
          class="close"
          (click)="AddQuestionpopup()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <!-- <app-fa-answer-choice-note (EditAddAnswerchoiceNoteclose)="EditAddAnswerchoiceNoteclose($event)" [EditAnswerChoiceNotePopup]="EditAnswerChoiceNotePopup" [selectedQuestionById]="selectedQuestionById"></app-fa-answer-choice-note> -->
        <app-fa-answer-choice-solution-hint
          (EditSolutionHintclose)="EditSolutionHintclose($event)"
          [EditSolutionHintPopup]="EditSolutionHintPopup"
          [selectedQuestionById]="selectedQuestionById"
        ></app-fa-answer-choice-solution-hint>
      </div>
    </div>
  </div>
</div>
<div class="modal fade show Model_popup1" *ngIf="Questionpreviewpopupflag">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Question Preview</h6>
        <button
          type="button"
          class="close"
          (click)="AddQuestionpopup()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-fa-question-preview
          (ReturnQuestionpreview)="ReturnQuestionpreview($event)"
          [previewdetail]="previewdetail"
        ></app-fa-question-preview>
      </div>
    </div>
  </div>
</div>

<div class="modal fade show Model_popup1" *ngIf="Questionreviewpopupflag">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Edit2">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">
          Review {{ Questionstatus }} Question
        </h6>
        <button
          type="button"
          class="close"
          (click)="AddQuestionpopup()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-fa-question-submit-for-review
          (ReturnQuestionreviewclose)="ReturnQuestionreviewclose($event)"
          [ScreenName1]="ScreenName1"
          (Questionreviewclose)="Questionreviewclose($event)"
          (CloseEditQuestion)="CloseEditQuestion($event)"
          [Questionstatus]="Questionstatus"
          [selectedQuestionById]="selectedQuestionById"
          [subjectById]="subjectById"
        ></app-fa-question-submit-for-review>
      </div>
    </div>
  </div>
</div>
<div class="modal fade show Model_popup1" *ngIf="QuestionStatuspopupflag">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Edit2">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">
          Question Status Changes History
        </h6>
        <button
          type="button"
          class="close"
          (click)="AddQuestionpopup()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <app-fa-questionstatus-history
          (ReturnQuestionStatushistory)="ReturnQuestionStatushistory($event)"
          [selectedQuestionById]="selectedQuestionById"
          [subjectById]="subjectById"
        ></app-fa-questionstatus-history>
      </div>
    </div>
  </div>
</div>

<!-- Search Question Modal -->
<div class="modal fade show Model_popup1" *ngIf="Searchmodelpopup">
  <div class="modal-dialog modal-dialog-centered modal-dialog-EditSearch">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Search Flash Cards</h6>
        <button
          type="button"
          class="close"
          (click)="SearchQuestionModel()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-3 py-0">
        <div class="row">
          <div class="col-12" style="height: 30vh !important; overflow: auto">
            <div class="row">
              <div class="col-12 py-1 p-1" *ngIf="selectedsubject">
                <div class="p-0">
                  <textarea
                    type="text"
                    [disabled]="
                      FromDate || ToDate || questionstatustype || OwnQuestionInd
                    "
                    maxlength="100"
                    Placeholder="Enter FlashCard here"
                    [(ngModel)]="QuestionKeyword1"
                    class="form-control form-control-sm"
                    (ngModelChange)="Descriptioncount()"
                  ></textarea>
                  <!-- <div class="row"> -->
                </div>

                <!-- </div> -->

                <!-- <div style="text-align: right;">

                  </div> -->
              </div>
            </div>
            <div class="row">
              <div class="col-10 py-0 p-1">
                <label class="Validquestion" *ngIf="error.isError">{{
                  error.errorMessage
                }}</label>
              </div>
              <div class="col-2 py-0 p-1" style="text-align: right">
                <label class="form-check-label maxlength" for="exampleCheck1"
                  >Characters {{ Descriptionvaluelength }}/{{
                    DescriptionMaxlength
                  }}</label
                >
              </div>
            </div>
            <div class="row">
              <div class="col-10 py-0 p-1">
                <label
                  class="Validquestion"
                  *ngIf="(!FromDate && ToDate) || (FromDate && !ToDate)"
                  >WARNING!!! Use a small date window.</label
                >
                <label
                  class="Validquestion"
                  *ngIf="!FromDate && !ToDate"
                ></label>
                <label class="Validquestion" *ngIf="FromDate && ToDate"></label>
              </div>
            </div>
            <div class="row">
              <div class="col-2 p-1 py-0" *ngIf="selectedsubject">
                <div class="p-0">
                  <input
                    type="text"
                    [ngClass]="{ borderview1: !FromDate && ToDate }"
                    required
                    Placeholder="From Date"
                    [disabled]="
                      QuestionKeyword1 != null && QuestionKeyword1 != ''
                    "
                    [(ngModel)]="FromDate"
                    [owlDateTime]="dt1"
                    [owlDateTimeTrigger]="dt1"
                    class="form-control form-control-sm"
                  />
                  <owl-date-time
                    [disabled]="
                      QuestionKeyword1 != null && QuestionKeyword1 != ''
                    "
                    [pickerType]="'calendar'"
                    #dt1
                  ></owl-date-time>
                </div>
              </div>
              <div class="col-2 p-1 py-0" *ngIf="selectedsubject">
                <div class="p-0">
                  <input
                    type="text"
                    [ngClass]="{ borderview1: FromDate && !ToDate }"
                    Placeholder="To Date"
                    [disabled]="
                      QuestionKeyword1 != null && QuestionKeyword1 != ''
                    "
                    [(ngModel)]="ToDate"
                    [owlDateTime]="dt2"
                    [owlDateTimeTrigger]="dt2"
                    class="form-control form-control-sm"
                  />
                  <owl-date-time
                    [disabled]="
                      QuestionKeyword1 != null && QuestionKeyword1 != ''
                    "
                    [pickerType]="'calendar'"
                    #dt2
                  ></owl-date-time>
                </div>
              </div>
              <div
                class="col-2 p-1 py-0"
                style="width: 170px"
                *ngIf="selectedsubject"
              >
                <div class="p-0">
                  <select
                    class="form-control form-control-sm"
                    [disabled]="
                      QuestionKeyword1 != null && QuestionKeyword1 != ''
                    "
                    [(ngModel)]="questionstatustype"
                  >
                    <option selected value="null" hidden>
                      Flash Card Status
                    </option>
                    <option
                      *ngFor="let s of getquestionstatustype; let i = index"
                      [value]="s.Code"
                    >
                      {{ s.Description }}
                    </option>
                  </select>
                </div>
              </div>
              <div
                class="col-2 p-1 py-0"
                style="width: 160px"
                *ngIf="selectedsubject"
              >
                <div class="p-0 pt-1">
                  <div class="form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      [disabled]="
                        QuestionKeyword1 != null && QuestionKeyword1 != ''
                      "
                      (click)="ClickOwnQuestionInd()"
                      [checked]="OwnQuestionInd"
                    />
                    <label class="form-check-label" for="exampleCheck1"
                      >Own Flash Card</label
                    >
                  </div>
                </div>
              </div>
              <!-- <div class="col-2 py-2 p-1"  style="width: 160px;" *ngIf="selectedsubject">
        <div class="p-0">

          <select  class="form-control form-control-sm " [(ngModel)]="selectOperator">
          <option selected value=null hidden>Select Operator</option>
          <option *ngFor="let s of operator;let i=index" [value]="s.Code">{{s.Description}}</option>
          </select>

      </div>



      </div> -->
            </div>

            <!-- <div class="row">
                <div class="col-12 py-1 p-1" *ngIf="selectedsubject">
                  <div class="p-0">
                    <textarea type="text" Placeholder="QuestionKeyword2" [(ngModel)]="QuestionKeyword2"
                    class="form-control form-control-sm"></textarea>
                </div>
                </div>
              </div> -->
            <div class="row">
              <div class="col-12 px-0 py-1 pt-2">
                <div class="d-flex justify-content-end">
                  <div class="px-1">
                    <button
                      type="button"
                      class="btn btn-sm bl-btn"
                      [disabled]="
                        (!FromDate &&
                          !ToDate &&
                          !QuestionKeyword1 &&
                          !selectOperator &&
                          !OwnQuestionInd) ||
                        (FromDate && !ToDate) ||
                        (!FromDate && ToDate)
                      "
                      (click)="FilterQuestion()"
                    >
                      Search
                    </button>
                  </div>
                  <div class="px-1">
                    <button
                      type="button"
                      class="btn btn-sm btn-light bg-light border"
                      (click)="Clear()"
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- QUESTIION ACTIVITY HISTORY MODAL  -->
<div class="modal fade show Model_popup1" *ngIf="ActivityHPop">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Activity History</h6>
        <button
          type="button"
          class="close"
          (click)="activityHistoryClose()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body px-3 py-0">
        <div class="row">
          <div class="col-12" style="height: 90vh !important; overflow: auto">
            <div class="row">
              <div class="col-12">
                <app-fa-question-list
                  [subjectById]="selectedsubject"
                  (openSelectedFlashCard)="openSelectedFlashCardEvent($event)"
                  [type]="'history'"
                ></app-fa-question-list>
                <!-- <app-question-list *ngIf="selectedlist==selectedsubjectquestion" [questionsubjectresponse]="questionsubjectresponse" [ScreenName1]="ScreenName1" (RefreshEditQuestion)="RefreshEditQuestion($event)" [Questionlistresponse]="Questionlistresponse" [subjectById]=subjectById></app-question-list>
                        <app-question-list *ngIf="selectedlist==selectedsubjectquestion" [questionsubjectresponse]="questionsubjectresponse" [ScreenName1]="ScreenName1" (RefreshEditQuestion)="RefreshEditQuestion($event)" [Questionlistresponse]="Questionlistresponse" [subjectById]="subjectById"></app-question-list>
                        <app-question-list *ngIf="selectedlist==selectedsubjectquestion" [questionsubjectresponse]="questionsubjectresponse" [ScreenName1]="ScreenName1" (RefreshEditQuestion)="RefreshEditQuestion($event)" [Questionlistresponse]="Questionlistresponse" [subjectById]="subjectById"></app-question-list>
                        <app-question-list *ngIf="selectedlist==selectedsubjectquestion" [questionsubjectresponse]="questionsubjectresponse" [ScreenName1]="ScreenName1" (RefreshEditQuestion)="RefreshEditQuestion($event)" [Questionlistresponse]="Questionlistresponse" [subjectById]="subjectById"></app-question-list>
                        <app-question-list *ngIf="selectedlist==selectedsubjectquestion" [questionsubjectresponse]="questionsubjectresponse" [ScreenName1]="ScreenName1" (RefreshEditQuestion)="RefreshEditQuestion($event)" [Questionlistresponse]="Questionlistresponse" [subjectById]="subjectById"></app-question-list>
                        <app-question-list *ngIf="selectedlist==selectedsubjectquestion" [questionsubjectresponse]="questionsubjectresponse" [ScreenName1]="ScreenName1" (RefreshEditQuestion)="RefreshEditQuestion($event)" [Questionlistresponse]="Questionlistresponse" [subjectById]="subjectById"></app-question-list>
                        <app-question-list *ngIf="selectedlist==selectedsubjectquestion" [questionsubjectresponse]="questionsubjectresponse" [ScreenName1]="ScreenName1" (RefreshEditQuestion)="RefreshEditQuestion($event)" [Questionlistresponse]="Questionlistresponse" [subjectById]="subjectById" ></app-question-list> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade show Model_popup1" *ngIf="filtermodelpopup">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Questions</h6>
        <button
          type="button"
          class="close"
          (click)="FilterModelpopup()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body px-3 py-0">
        <div class="row">
          <div class="col-12" style="height: 90vh !important; overflow: auto">
            <div class="row">
              <div class="col-12" *ngIf="getquestionFilterlist">
                <app-tinyedneditor
                  [getquestionFilterlist]="getquestionFilterlist"
                  (FilteredQuestionEditButton)="
                    FilteredQuestionEditButton($event)
                  "
                ></app-tinyedneditor>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="ActivityHistoryflag">
            <div class="col-12">
              <!-- <app-fa-question-list
                #childComponent
                (RefreshEditQuestion)="RefreshEditQuestion($event)"
                [subjectById]="subjectById"
                [questionsubjectresponse]="questionsubjectresponse"
              ></app-fa-question-list> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

<div class="modal fade show Model_popup1" *ngIf="ActivityHisotrypopupflag">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Activity History</h6>
        <button
          type="button"
          class="close"
          (click)="ViewActivityHistory()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body px-3 py-0">
        <div class="row">
          <div class="col-12" style="height: 90vh !important; overflow: auto">
            <div class="row">
              <div class="col-12" *ngIf="ActivityHistorylist">
                <app-tinyedneditor
                  [ActivityHistorylist]="ActivityHistorylist"
                  (EditButton)="EditButton($event)"
                ></app-tinyedneditor>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="ActivityHistoryflag">
            <div class="col-12">
              <!-- <app-fa-question-list
                #childComponent
                (RefreshEditQuestion)="RefreshEditQuestion($event)"
                [subjectById]="subjectById"
                [questionsubjectresponse]="questionsubjectresponse"
              ></app-fa-question-list> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- (ClickAnswerChoice)="ClickAnswerChoice($event)"

                  (ClickQuestionPreview)="ClickQuestionPreview($event)"
                   [EditQuestionFlag]="EditQuestionFlag"
                 (CloseEditQuestion)="CloseEditQuestion($event)"
                 (EditAnswerNote)="EditAnswerNote($event)" -->
</div>

<div class="modal fade show Model_popup1" *ngIf="Questionlistpopupflag">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Question-add">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Flash Card List</h6>
        <button
          type="button"
          class="close"
          (click)="ViewQuestionlistpopupflag()"
          style="padding-right: 20px; font-size: 30px; outline: 0"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body px-3 py-0">
        <div class="row">
          <div class="col-12" style="height: 90vh !important; overflow: auto">
            <div class="row">
              <div class="col-12">
                <app-fa-question-list
                  [subjectById]="subjectById"
                  (openSelectedFlashCard)="openSelectedFlashCardEvent($event)"
                  [type]="'list'"
                ></app-fa-question-list>
                <!-- <app-question-list *ngIf="selectedlist==selectedsubjectquestion" [questionsubjectresponse]="questionsubjectresponse" [ScreenName1]="ScreenName1" (RefreshEditQuestion)="RefreshEditQuestion($event)" [Questionlistresponse]="Questionlistresponse" [subjectById]=subjectById></app-question-list>
                        <app-question-list *ngIf="selectedlist==selectedsubjectquestion" [questionsubjectresponse]="questionsubjectresponse" [ScreenName1]="ScreenName1" (RefreshEditQuestion)="RefreshEditQuestion($event)" [Questionlistresponse]="Questionlistresponse" [subjectById]="subjectById"></app-question-list>
                        <app-question-list *ngIf="selectedlist==selectedsubjectquestion" [questionsubjectresponse]="questionsubjectresponse" [ScreenName1]="ScreenName1" (RefreshEditQuestion)="RefreshEditQuestion($event)" [Questionlistresponse]="Questionlistresponse" [subjectById]="subjectById"></app-question-list>
                        <app-question-list *ngIf="selectedlist==selectedsubjectquestion" [questionsubjectresponse]="questionsubjectresponse" [ScreenName1]="ScreenName1" (RefreshEditQuestion)="RefreshEditQuestion($event)" [Questionlistresponse]="Questionlistresponse" [subjectById]="subjectById"></app-question-list>
                        <app-question-list *ngIf="selectedlist==selectedsubjectquestion" [questionsubjectresponse]="questionsubjectresponse" [ScreenName1]="ScreenName1" (RefreshEditQuestion)="RefreshEditQuestion($event)" [Questionlistresponse]="Questionlistresponse" [subjectById]="subjectById"></app-question-list>
                        <app-question-list *ngIf="selectedlist==selectedsubjectquestion" [questionsubjectresponse]="questionsubjectresponse" [ScreenName1]="ScreenName1" (RefreshEditQuestion)="RefreshEditQuestion($event)" [Questionlistresponse]="Questionlistresponse" [subjectById]="subjectById"></app-question-list>
                        <app-question-list *ngIf="selectedlist==selectedsubjectquestion" [questionsubjectresponse]="questionsubjectresponse" [ScreenName1]="ScreenName1" (RefreshEditQuestion)="RefreshEditQuestion($event)" [Questionlistresponse]="Questionlistresponse" [subjectById]="subjectById" ></app-question-list> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

